"use client"
import { createContext, useContext } from "react"
import { type CurrencyPreference, defaultCurrency } from "./utils"

export const CurrencyContext = createContext<{
  currency: CurrencyPreference
  setCurrency: (value: CurrencyPreference) => void
  toggleCurrency: () => void
}>({
  currency: defaultCurrency,
  setCurrency: () => null,
  toggleCurrency: () => null,
})

export const useCurrency = () => {
  return useContext(CurrencyContext)
}
